import { useContext } from 'react'
import { TriggerContainer } from '../styled-components'
import { ContextMenuContext } from './context-menu-context'

const ContextMenuTrigger = ({ children, callback, disabled }) => {
  const { handleIsOpen } = useContext(ContextMenuContext)

  const handleTrigger = (event) => {
    if (disabled) return

    handleIsOpen()
    callback && callback(event)
  }
  return <TriggerContainer onClick={handleTrigger}>{children}</TriggerContainer>
}

export default ContextMenuTrigger
